module.exports = __webpack_public_path__ + "img/down.513b07e4.png";